
/**
 * 埋点事件管理
 * Track类，
 * add方法：保存需要上传的参数，在埋点流程中依次保存
 * send方法：上传事件
 * clear方法：清空当前保存的参数
 */
class Track {
	constructor(key, name) {
		this.key = key;
		this.name = name;
		this.gioParams = {};
		this.disabled = false;
	}
	add(obj) {
		if (Object.prototype.toString.call(obj) !== '[object Object]') {
			return
		}
		this.gioParams = {
			...this.gioParams,
			...obj
		}
		return this;
	}
	get(key) {
		return key ? this.gioParams[key] : this.gioParams;
	}
	send() {
		if (this.disabled) return this

		if (process.env.NODE_ENV === 'development') {
		    console.log('---gio---', this.key +'-'+ this.name, {
				...this.gioParams
			})
		}
		
		gio('track', this.key, {
			...this.gioParams
		})
		return this;
	}
	clear() {
		this.gioParams = {}
	}
	setStatus(status) {
		this.disabled = status
	}
}


const createTrack = (function() {
	let cache = {};
	return function(key, name) {
		if (cache[key]) {
			return cache[key]
		}
		return cache[key] = new Track(key, name)
	}
})()

export default createTrack